import { render, staticRenderFns } from "./MedalPopupQueue.vue?vue&type=template&id=3eb2d23d&"
import script from "./MedalPopupQueue.vue?vue&type=script&lang=js&"
export * from "./MedalPopupQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports